@if (versionCheckService.notifiedVersion$ | async) {
  <div class="alert alert-info d-flex justify-content-center align-items-center gap-3 mb-0 rounded-0" role="status">
    <span>A new version of BinView is available</span>
    <button mat-stroked-button color="primary" (click)="versionCheckService.reload()">Reload</button>
    <button mat-icon-button aria-label="Dismiss" (click)="versionCheckService.dismiss()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
}
